import React from 'react';
import PropTypes from 'prop-types';
import { DetailPanelData } from "../Common/DetailPanel"
import { formatSQLDateTime, FormatDate } from '../../utils';

const SystemAdminInventoryHeaders = ({
    data
}) => (
    <>
        <DetailPanelData id='CreatedByHeader' title="CREATED BY" data={data.createdByName}  />
        <DetailPanelData id='CreatedOnHeader' title="CREATED ON" data={FormatDate(data.createDate)}  />
        <DetailPanelData id='LastUpdatedByHeader' title="LAST UPDATED BY" data={data.updatedByName}  />
        <DetailPanelData id='LastUpdatedOnHeader' title="LAST UPDATED ON" data={FormatDate(data.updateDate)}  />
    </>
);

SystemAdminInventoryHeaders.propTypes = {
    data: PropTypes.object.isRequired,
};

export default SystemAdminInventoryHeaders;
